// Fetch list

export const FETCH = 'salesTypes.FETCH'
export const FETCH_STARTED = 'salesTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'salesTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'salesTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'salesTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'salesTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'salesTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'salesTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'salesTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'salesTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'salesTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'salesTypes.SAVE'
export const SAVE_STARTED = 'salesTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'salesTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'salesTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'salesTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'salesTypes.DELETE'
export const DELETE_STARTED = 'salesTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'salesTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'salesTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'salesTypes.DELETE_CANCELLED'
